import { supabase } from "./supabaseClient";

function isoDate(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x.toISOString();
}

export async function fetchPingsForRange({ daysBack = 30 }) {
  const start = new Date();
  start.setDate(start.getDate() - (daysBack - 1));
  start.setHours(0, 0, 0, 0);

  const { data, error } = await supabase
    .from("pings")
    .select("id,sender_id,kind,note,created_at")
    .gte("created_at", isoDate(start))
    .order("created_at", { ascending: true });

  return { data: data || [], error };
}
